import L from 'leaflet';

const PinIcon = new L.Icon({
    iconUrl: require('../../pin.svg'),
    iconSize: new L.Point(10, 10),
});

export default PinIcon;